
<template>

<el-tabs v-model="activeName" type="card">
    <el-tab-pane label="已入驻商家" name="first" :lazy="true">
        <joined-business></joined-business>
    </el-tab-pane>
    <el-tab-pane label="入驻申请" name="second">
        <apply-business></apply-business>
    </el-tab-pane>
</el-tabs>

</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import applyBusiness from './applyBusiness'
import joinedBusiness from './joinedBusiness'
export default {
  name: 'plus-business-tab-index',
  extends: BasicPager,
  components: {
    applyBusiness,
    joinedBusiness
  },
  data () {
    return {
      activeName: 'first'
    }
  },
  created () {
    let params = this.$route.params
    if (params.activeName) {
      this.activeName = params.activeName
    }
  }
}

</script>
